import React from 'react';
import { Divider as MuiDivider, type DividerProps } from '@material-ui/core';

const Divider = (props: DividerProps) => (
  <MuiDivider style={{ marginBottom: '2rem', marginTop: '2rem' }} {...props} />
);

export default Divider;
